export default function toElement(html, tagName = 'div') {
  if (typeof window !== 'undefined') {
    const contentEl = document.createElement(tagName);
    contentEl.innerHTML = html;
    return contentEl;
  }
}
